export default "__VITE_ASSET__Ob9DYNX3__"